package ro.horatiu_udrea.resursedeblocat

val theoryResourcesKey = "theory_resources"
val practicalActionsKey = "practical_actions"
val workHoursKey = "work_hours"
val workEnergyKey = "work_energy"
val environmentEnergyKey = "environment_energy"
val weeklyIncomeKey = "weekly_income"
val wellBeingKey = "well_being"
val notWellBeingKey = "not_well_being"
val participatedMinigroupKey = "participated_minigroup"
val interactionMinigroupKey = "interaction_minigroup"
val joinMinigroupKey = "join_minigroup"
val deblocatMomentKey = "deblocat_moment"
val anythingElseKey = "anything_else"

// Default values for tracking
val theoryResourcesDefault = emptyList<String>()
val practicalActionsDefault = emptyList<String>()
val workHoursDefault = 40
val weeklyIncomeDefault = 0
val energyDefault = 5
val wellBeingDefault = ""
val notWellBeingDefault = ""
val participatedMinigroupDefault = false
val interactionMinigroupDefault = ""
val joinMinigroupDefault = false
val deblocatMomentDefault = ""
val anythingElseDefault = ""

val trackingSteps = 12

data class MonthlyTracking(
    val id: String = "",
    val month: Int, // 1-12
    val year: Int,
    val answers: Map<String, Any> = emptyMap(), // Store as Any to support String, List<String>, Int
    val completed: Boolean = false,
    val updatedAt: Long = 0
)
